export class PartnerWalletTransferFundsModel {
    public amount: number;
    public description: string;
    public sourceWalletId: number | null;
    public destinationWalletId: number | null;
}

export class PartnerWalletDownloadStatementModel {
  public walletId: number | null;
  public from: Date;
  public to: Date;
  public format: string;
}
